module.exports = __webpack_public_path__ + "img/my_center_bg.b29f7619.png";